var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute z-10 p-2 m-3 font-mono text-white bg-black rounded text-xxs",style:({ left: _vm.coordinates.x + 'px', top: _vm.coordinates.y + 'px' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }